// src/components/Toast/ToastProvider.js
// Sistema de notificaciones no bloqueante que reemplaza a window.alert().
// Uso: const { showToast } = useToast(); showToast('Mensaje', 'success');
import React, { createContext, useContext, useState, useCallback } from 'react';
import './Toast.css';

const ToastContext = createContext({ showToast: () => {} });

export const useToast = () => useContext(ToastContext);

let toastId = 0;

const ICONS = {
  success: 'bi-check-circle-fill',
  danger: 'bi-x-circle-fill',
  warning: 'bi-exclamation-triangle-fill',
  info: 'bi-info-circle-fill',
};

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  const showToast = useCallback(
    (message, type = 'info', duration = 4500) => {
      const id = ++toastId;
      setToasts((prev) => [...prev, { id, message, type }]);
      if (duration > 0) {
        setTimeout(() => removeToast(id), duration);
      }
      return id;
    },
    [removeToast]
  );

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <div className="toast-container-custom" aria-live="polite" aria-atomic="true">
        {toasts.map((t) => (
          <div
            key={t.id}
            className={`alert alert-${t.type} shadow toast-item-custom`}
            role="alert"
          >
            <i className={`bi ${ICONS[t.type] || ICONS.info} me-2`}></i>
            <span className="toast-message-custom">{t.message}</span>
            <button
              type="button"
              className="btn-close ms-auto"
              aria-label="Cerrar"
              onClick={() => removeToast(t.id)}
            ></button>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
};

export default ToastProvider;
